import * as Cesium from "cesium";

export const ENTITY_PREFIX = "viewer-measurement";

export const buildLineEntityId = (measurementId: string) =>
  `${ENTITY_PREFIX}-${measurementId}-line`;
export const buildStartPointEntityId = (measurementId: string) =>
  `${ENTITY_PREFIX}-${measurementId}-start`;
export const buildEndPointEntityId = (measurementId: string) =>
  `${ENTITY_PREFIX}-${measurementId}-end`;
export const buildLabelEntityId = (measurementId: string) =>
  `${ENTITY_PREFIX}-${measurementId}-label`;

export const PENDING_POINT_ENTITY_ID = `${ENTITY_PREFIX}-pending-point`;
export const PREVIEW_LINE_ENTITY_ID = `${ENTITY_PREFIX}-preview-line`;
export const PREVIEW_LABEL_ENTITY_ID = `${ENTITY_PREFIX}-preview-label`;

export const MEASUREMENT_LINE_MATERIAL = Cesium.Color.CYAN.withAlpha(0.95);
export const MEASUREMENT_LINE_DEPTH_FAIL_MATERIAL =
  new Cesium.ColorMaterialProperty(MEASUREMENT_LINE_MATERIAL);
export const PREVIEW_LINE_MATERIAL = Cesium.Color.YELLOW.withAlpha(0.9);
export const PREVIEW_LINE_DEPTH_FAIL_MATERIAL =
  new Cesium.ColorMaterialProperty(PREVIEW_LINE_MATERIAL);

export const DRAG_POINT_PICK_TOLERANCE_PIXELS = 14;

export const HEIGHT_SENSITIVITY = 0.8;
export const CAMERA_PIVOT_DURATION_MS = 420;
export const HEIGHT_VIEW_PITCH_RAD = Cesium.Math.toRadians(-22);
export const HEIGHT_VIEW_MIN_RANGE_METERS = 60;
export const HEIGHT_VIEW_MAX_RANGE_METERS = 320;
export const HEIGHT_IDEAL_PITCH_TOLERANCE_RAD = Cesium.Math.toRadians(18);
export const HEIGHT_VIEW_LOGICAL_RANGE_MIN_METERS = 8;
export const HEIGHT_VIEW_LOGICAL_RANGE_MAX_METERS = 1400;
export const HEIGHT_VIEW_LOGICAL_MIN_RELATIVE_HEIGHT_METERS = 0.5;
export const HEIGHT_VIEW_LOGICAL_MAX_RELATIVE_HEIGHT_METERS = 650;
export const DISTANCE_VIEW_LOGICAL_RANGE_MAX_METERS = 1400;
